import type { RowData } from "@tanstack/react-table";
import type { DataGridOverflow, DataGridTable } from "../columns/types";
import { CellText, type CellTextTone } from "./CellText";
import { HighlightedText } from "./HighlightedText";

interface SearchableTextProps<TData extends RowData> {
    text: string;
    overflow: DataGridOverflow;
    table: DataGridTable<TData>;
    tone?: CellTextTone;
}

/** Cell text with search matches highlighted; what every text-like cell renders. */
export const SearchableText = <TData extends RowData>({
    text,
    overflow,
    table,
    tone,
}: Readonly<SearchableTextProps<TData>>) => (
    <CellText text={text} overflow={overflow} tone={tone}>
        <HighlightedText text={text} table={table} />
    </CellText>
);
